// extracted by mini-css-extract-plugin
export default {"pagePhotos":"Photos_pagePhotos__zBGc6","gallery":"Photos_gallery__LyEoZ","photoCard":"Photos_photoCard__SOzDT","wide":"Photos_wide__NHzEB","star":"Photos_star__iz9YW"};